import { AnimationStretchMode, FrameAnimation } from "../components/FrameAnimation";
import { HideFlags } from "../Const";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { GWidget } from "./GWidget";
export class GMovieClip extends GWidget {
    constructor() {
        super();
        this._color = "#ffffff";
        this.comp = this.addComponent(FrameAnimation);
        this.comp.hideFlags |= HideFlags.HideAndDontSave;
        this.comp.stretchMode = AnimationStretchMode.ResizeToFit;
    }
    get src() {
        return this.comp.source;
    }
    set src(value) {
        this.comp.source = value;
    }
    get icon() {
        return this.src;
    }
    set icon(value) {
        this.src = value;
    }
    get autoSize() {
        return this.comp.stretchMode === AnimationStretchMode.ResizeToFit;
    }
    set autoSize(value) {
        this.comp.stretchMode = value ? AnimationStretchMode.ResizeToFit : AnimationStretchMode.Fill;
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this.comp.color.parse(value);
        this.comp.color = this.comp.color;
    }
    get frame() {
        return this.comp.frame;
    }
    set frame(value) {
        this.comp.frame = value;
    }
    get isPlaying() {
        return this.comp.isPlaying;
    }
    get autoPlay() {
        return this.comp.autoPlay;
    }
    set autoPlay(value) {
        this.comp.autoPlay = value;
    }
    get loop() {
        return this.comp.loop;
    }
    set loop(value) {
        this.comp.loop = value;
    }
    get timeScale() {
        return this.comp.timeScale;
    }
    set timeScale(value) {
        this.comp.timeScale = value;
    }
    _sizeChanged(changeByLayout) {
        super._sizeChanged();
        if (!changeByLayout && !SerializeUtil.isDeserializing)
            this.autoSize = false;
    }
}
